export const FULFILLMENT_VIEW_KEY = "groove.orderFulfillment.view.v1";
const workViews = ["all", "active", "needs_selection", "to_prepare", "ready_at_counter", "ready_dispatch", "shipping_tracking", "shipping", "attention", "completed", "completion_unknown", "placement"];
const presets = ["all", "today", "yesterday", "this_week", "last_week", "this_month", "last_month", "custom"];
const string = value => typeof value === "string" ? value : "";

export function sidebarReference(order) {
  if (!order || typeof order._id !== "string" || !order._id) return null;
  const bundle = order.type === "bundle" || order.lane === "bundle";
  // Persist navigation only. Details and business status are always fetched again.
  return {
    _id: order._id,
    type: bundle ? "bundle" : "order",
    lane: bundle ? "bundle" : "pass",
    ...(bundle ? { box_id: string(order.box_id) || order._id } : {}),
    sidebarMode: order.sidebarMode === "history" || order.isHandOff === true ? "history"
      : ["prepare", "handoff", "reconcile", "amount_due"].includes(order.sidebarMode) || order.prepare_status === "prepared" ? "prepare" : undefined,
  };
}

export function readFulfillmentView() {
  try {
    const stored = JSON.parse(sessionStorage.getItem(FULFILLMENT_VIEW_KEY) || "{}");
    if (!stored || typeof stored !== "object" || Array.isArray(stored)) return {};
    return {
      origin: string(stored.origin), method: string(stored.method), payment: string(stored.payment),
      lane: ["pass", "bundle"].includes(stored.lane) ? stored.lane : "",
      work: workViews.includes(stored.work) ? stored.work : "all",
      datePreset: presets.includes(stored.datePreset) ? stored.datePreset : "all",
      from: /^\d{4}-\d{2}-\d{2}$/.test(stored.from) ? stored.from : "",
      to: /^\d{4}-\d{2}-\d{2}$/.test(stored.to) ? stored.to : "",
      search: string(stored.search).slice(0, 100), queueSearch: string(stored.queueSearch).slice(0, 100),
      page: Number.isSafeInteger(stored.page) && stored.page > 0 ? stored.page : 1,
      count: [10, 25, 50, 100].includes(stored.count) ? stored.count : 50,
      sidebar: sidebarReference(stored.sidebar),
    };
  } catch { return {}; }
}

export function saveFulfillmentView(view) {
  try { sessionStorage.setItem(FULFILLMENT_VIEW_KEY, JSON.stringify({ ...view, sidebar: sidebarReference(view.sidebar) })); }
  catch { /* The page remains usable when browser storage is unavailable. */ }
}

export function clearFulfillmentView() {
  try { sessionStorage.removeItem(FULFILLMENT_VIEW_KEY); }
  catch { /* Storage may be unavailable. */ }
}
